/* ==========================================================================
   Zabi Hair — Motion-systeem (Web Animations API)
   <motion-element data-motion="fade-in|fade-in-up|fade-in-left|fade-in-right">
   Stagger: kinderen met [data-motion-item] krijgen 100ms per item.
   Progressive enhancement: zonder JS/observer is alles gewoon zichtbaar;
   pre-hide gebeurt pas vlak voor de animatie start.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 600;
  var EASING = 'cubic-bezier(0, 0, 0.3, 1)';
  var STAGGER = 100;

  function startFrame(type) {
    switch (type) {
      case 'fade-in-up': return { opacity: 0, transform: 'translateY(2rem)' };
      case 'fade-in-left': return { opacity: 0, transform: 'translateX(-2rem)' };
      case 'fade-in-right': return { opacity: 0, transform: 'translateX(2rem)' };
      default: return { opacity: 0, transform: 'none' };
    }
  }

  function animateIn(el, type, delay) {
    var from = startFrame(type);
    try {
      var anim = el.animate(
        [from, { opacity: 1, transform: 'none' }],
        { duration: DURATION, easing: EASING, delay: delay || 0, fill: 'backwards' }
      );
      var clear = function () { el.style.opacity = ''; el.style.transform = ''; };
      anim.onfinish = clear;
      /* Watchdog: bevroren timelines (occluded window, throttled rAF) mogen
         content nooit verborgen houden — forceer einde na de eigen looptijd. */
      setTimeout(function () {
        try { if (anim.playState !== 'finished') anim.finish(); } catch (e) { clear(); }
      }, (delay || 0) + DURATION + 400);
    } catch (e) {
      el.style.opacity = '';
      el.style.transform = '';
    }
  }

  var observer = null;
  if (!REDUCED && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.reveal();
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -50px 0px' }
    );
  }

  class MotionElement extends HTMLElement {
    connectedCallback() {
      this.classList.add('zabi-motion--in'); /* legacy-hook; CSS verbergt niets meer */
      if (REDUCED || !observer) return;
      observer.observe(this);
    }

    reveal() {
      if (this.__revealed) return;
      this.__revealed = true;
      var type = this.getAttribute('data-motion') || 'fade-in';
      var baseDelay = parseInt(this.getAttribute('data-motion-delay'), 10) || 0;
      var items = this.querySelectorAll('[data-motion-item]');
      if (items.length) {
        items.forEach(function (item, i) {
          animateIn(item, type, baseDelay + i * STAGGER);
        });
      } else {
        animateIn(this, type, baseDelay);
      }
    }
  }

  if (!customElements.get('motion-element')) {
    customElements.define('motion-element', MotionElement);
  }
})();
